import React from 'react'
import { Text } from '@clear/design-system'

interface AccessibilityLocationProps {
  isAccessible: boolean
  accessibilityMessage: string
}

export const AccessibleLocation = ({
  isAccessible,
  accessibilityMessage,
}: AccessibilityLocationProps) => {
  return (
    <Text mb={3}>
      <span className="flex gap-2 items-center">
        {isAccessible ? (
          <>
            <img src="/wheelchair-logo.svg" alt="Accessible logo" />
            Accessible Enrollment Location
          </>
        ) : (
          <>{accessibilityMessage}</>
        )}
      </span>
    </Text>
  )
}
